import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { MBank, SuppliedBy } from './SuppliedBy.styles';

export default memo(({ license }: { license: string }) => (
  <SuppliedBy data-testid="supplied-by:container">
    <FormattedMessage id="header.handledBy" />
    <MBank data-testid="header.supplied-by:value">
      <FormattedMessage id={`header.${license}`} />
    </MBank>
  </SuppliedBy>
));
